import React from "react";
import { AnalyticsApi } from "../../api/user";
import { Details } from "../../models/Details";
import "../../style/style.scss";

interface AgeProp {
	detail: Details;
	valueSelected(response?: any): void;
}

const Age: React.FC<AgeProp> = ({ detail, valueSelected }): JSX.Element => {
	const [age, setAge] = React.useState(0);
	const [enabled, setEnabled] = React.useState(false);

	const valueClicked = () => {
		AnalyticsApi.logEvent('Age Added');
		valueSelected(age);
	};

	const changeAge = (event: any) => {
		const age = parseInt(event.target.value);
		setAge(age);
		if (detail.setAge(age)) {
			setEnabled(true);
		} else {
			setEnabled(false);
		}
	};

	React.useEffect(() => {
		if (typeof detail.age !== 'undefined') {
			setAge(detail.age);
			setEnabled(true);
		}
	}, []);

	return (
		<div className="content">
			<div className="inputDiv">
				<input
					type="number"
					min="18"
					max="120"
					className="hugeInput"
					value={age === 0 ? "" : age.toString()}
					onChange={changeAge}
				></input>
			</div>
			<div className="smallSubtext">Valid age is 18-120</div>
			<div className="">
				{enabled ? (
					<button className="greenButton" onClick={(e) => valueClicked()}>
						Next
					</button>
				) : (
					<button className="lightGrayButton">Next</button>
				)}
			</div>
		</div>
	);
};

export default Age;
